import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import classnames from 'classnames';
import DialogTitle from '@mui/material/DialogTitle';
import { createDialogTitleTheme, StyledModalHeader, TITLE_ROOT_PREFIX } from './modalStyles';
import { useIntl } from 'react-intl';
import { InteractiveIcon } from '../interactiveIcon';
export var EmbersModalTitle = function EmbersModalTitle(_ref) {
  var title = _ref.title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'transactional' : _ref$type,
    className = _ref.className,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? true : _ref$closeable,
    onClose = _ref.onClose,
    prefixIconName = _ref.prefixIconName;
  var intl = useIntl();
  var renderIcon = function renderIcon() {
    var iconName, ariaLabel;
    switch (type) {
      case 'destructive':
        iconName = 'icon-error';
        ariaLabel = intl.formatMessage({
          id: 'embers.statusIcon.alert',
          defaultMessage: 'alert'
        });
        break;
      case 'warning':
        iconName = 'icon-notification';
        ariaLabel = intl.formatMessage({
          id: 'embers.statusIcon.warn',
          defaultMessage: 'warning'
        });
        break;
      case 'error':
        iconName = 'icon-alert';
        ariaLabel = intl.formatMessage({
          id: 'embers.statusIcon.alert',
          defaultMessage: 'alert'
        });
        break;
      default:
        break;
    }
    return prefixIconName || iconName ?
    /*#__PURE__*/
    // Not using status icons here because size and colors do not quite align with that of the status icons
    React.createElement("span", {
      role: "img",
      "aria-label": ariaLabel,
      className: classnames("".concat(TITLE_ROOT_PREFIX, "-icon"), prefixIconName ? prefixIconName : iconName)
    }) : null;
  };
  var renderCloseBtn = function renderCloseBtn() {
    return closeable ? /*#__PURE__*/React.createElement(InteractiveIcon, {
      className: "".concat(TITLE_ROOT_PREFIX, "-close"),
      iconName: "icon-close",
      iconColor: "text",
      hoverColor: "grey",
      onClick: onClose
    }) : null;
  };
  var titleDisp;
  if (type !== 'feedback') {
    titleDisp = /*#__PURE__*/React.createElement("span", {
      className: "EmbersModalTitle-title"
    }, title);
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createDialogTitleTheme
  }, /*#__PURE__*/React.createElement(StyledModalHeader, {
    className: classnames("".concat(TITLE_ROOT_PREFIX, "-root"), "".concat(TITLE_ROOT_PREFIX, "-").concat(type, "-header"), _defineProperty({}, "".concat(TITLE_ROOT_PREFIX, "-hasCloseBtn"), closeable))
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    className: classnames("".concat(TITLE_ROOT_PREFIX, "-").concat(type), className)
  }, renderIcon(), titleDisp), renderCloseBtn()));
};